var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PureComponent } from "react";
import { isFunction } from "lodash";
import { hangPromise } from "@irati/utils/promise";
import getTenantFromPath from "@irati/identity/helpers/getTenantFromPath/index";
import getRegionHelper from "../helpers/getRegion";
var RegionProvider = /** @class */ (function (_super) {
    __extends(RegionProvider, _super);
    function RegionProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise()
        };
        return _this;
    }
    RegionProvider.prototype.componentDidMount = function () {
        var useSubdomain = this.props.useSubdomain;
        if (useSubdomain) {
            var load = getRegionHelper(getTenantFromPath());
            this.setState({ load: load });
        }
        else {
            this.setState({ load: Promise.resolve() });
        }
    };
    RegionProvider.prototype.render = function () {
        var children = this.props.children;
        var load = this.state.load;
        if (isFunction(children)) {
            return children({ load: load });
        }
        return children;
    };
    RegionProvider.defaultProps = {
        useSubdomain: false
    };
    return RegionProvider;
}(PureComponent));
export default RegionProvider;
